import { Form } from "react-bootstrap";
import "./YesOrNoCheckBox.css";

interface YesOrNoProp {
  title: string;
  approved?: boolean | null;
  radioGroup: string;
  onChange: (approved: boolean) => void;
  alignRight?: boolean;
  showColon?: boolean;
  useCheckboxModel?: boolean;
}

const YesOrNoCheckbox = ({
  approved,
  title,
  radioGroup,
  onChange,
  alignRight = false,
  showColon = true,
  useCheckboxModel = false,
}: YesOrNoProp) => {

  const handleOnChange = (check: boolean) => {
    onChange(check);
  };

  return (
    <Form.Group className={`yes-no-group fw-bold ${alignRight ? "yes-no-group-right" : ""}`}>
      <div className="yes-no-title">{title}{showColon ? ":" : ""}</div>
      <div className="yes-no-options">
        <Form.Check
          checked={approved === true}
          onChange={() => handleOnChange(true)}
          className="yes-no-option"
          inline
          type={useCheckboxModel ? "checkbox" : "radio"}
          label={useCheckboxModel ? "JA" : "Ja"}
          name={radioGroup}
          id={`${radioGroup}-ja`} />
        <Form.Check
          checked={approved === false}
          onChange={() => handleOnChange(false)}
          className="yes-no-option"
          inline
          type={useCheckboxModel ? "checkbox" : "radio"}
          label={useCheckboxModel ? "NEJ" : "Nej"}
          name={radioGroup}
          id={`${radioGroup}-nej`} />
      </div>
    </Form.Group>
  )
}

export default YesOrNoCheckbox;
